var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-5"},[_c('sign-up-sign-in')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }